import { makePostRequest } from './makeRequest';

const postWishlist = (data) => makePostRequest('api/users/self/wishlist', data);

export default postWishlist;
